import { ComponentType, useMemo } from 'react';
import { FilterFns, FilterFnOption } from '@tanstack/react-table';
import { BooleanSelectFilterInput } from './BooleanSelectFilterInput';
import { OptionFilterInput } from './OptionFilterInput';
import { ValidPeriodFilterInput } from './ValidPeriodFilterInput';
import { DefaultFilterInput } from './DefaultFilterInput';
import { FilterInputProps } from './FilterInputProps';
import { SelectFilterInput } from './SelectFilterInput';
import { ValidTimePeriodFilterInput } from './ValidTimePeriodFilterInput';

const filterInputs: Partial<
  Record<keyof FilterFns, ComponentType<FilterInputProps>>
> = {
  includesOption: OptionFilterInput,
  formattedDate: ValidPeriodFilterInput,
  formattedDateTime: ValidTimePeriodFilterInput,
  validPeriod: ValidPeriodFilterInput,
  booleanSelect: BooleanSelectFilterInput,
  select: SelectFilterInput,
};

export const registerFilterInput = <K extends keyof FilterFns>(
  name: K,
  component: ComponentType<FilterInputProps>,
) => {
  if (name in filterInputs) {
    throw new Error(`Filter input ${name} already registered`);
  }
  filterInputs[name] = component;
};

export const useFilterInput = (filterFnOption?: FilterFnOption<any>) =>
  useMemo(
    () =>
      (typeof filterFnOption === 'string' &&
        filterFnOption !== 'auto' &&
        filterFnOption in filterInputs &&
        filterInputs[filterFnOption as keyof FilterFns]) ||
      DefaultFilterInput,
    [filterFnOption],
  );
